import React from 'react'
import { Button } from '../Button'
import { Card } from '.'

export const card = () => (
  <Card>
    <span>Some label</span>
    <br />
    <Button>Cool button</Button>
  </Card>
)

export default {
  component: Card,
  title: 'Card',
}
